module.exports = __webpack_public_path__ + "assets/img/_flamengo2.9fc350b6.png";